import { ConvertToBase64 } from '../helper/commonHelper';
import { Axios } from './Axios';
import { uploadFile } from './upload.file.service';

export async function fetchResourcesByClassId(classId, limit = 10, offset = 1, type = '') {
  let url = `/resources?classId=${classId}&limit=${limit}&page=${offset}&sortBy=createdAt:desc`;
  if (type) {
    url = `/resources?classId=${classId}&limit=${limit}&page=${offset}&sortBy=createdAt:desc&type=${type}`;
  }
  return Axios({
    url,
    method: 'get'
  });
}

export async function uploadFileResource(classId, file, orgId, userId) {
  const base64 = await ConvertToBase64(file);
  return new Promise((resolve, reject) => {
    const fileObj = {
      base64,
      fileType: file.type,
      fileName: file.name,
      uploadFor: 'resource',
      userId,
      orgId: orgId?._id ?? orgId
    };
    // eslint-disable-next-line consistent-return
    uploadFile(classId, fileObj).then((fileRes) => {
      if (fileRes) {
        const path = `classes/${classId}/resources`;
        const fileType = file.type.split('/');
        const fileObj = {
          orgId: orgId?._id ?? orgId,
          type: 'file',
          storageSrc: 'firebase',
          name: file.name,
          fileFormat: fileType[1],
          file: fileRes.fileURL
        };
        resolve();
        return Axios({
          url: path,
          method: 'post',
          data: fileObj
        });
      }
      reject();
    });
  });
}

export async function createLinkResource(classId, resourceObj) {
  const url = `classes/${classId}/resources`;
  return Axios({
    url,
    method: 'post',
    data: resourceObj
  });
}

export async function deleteResource(resourceId) {
  const url = `resources/${resourceId}`;
  return Axios({
    url,
    method: 'delete'
  });
}

export async function fetchLinkTitle(link) {
  const url = `live/url?url=${link}`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function updateResource(resourceId, resObj) {
  const url = `resources/${resourceId}`;
  return Axios({
    url,
    method: 'patch',
    data: resObj
  });
}
